import { render, staticRenderFns } from "./Interactivity.vue?vue&type=template&id=089173c8&scoped=true"
import script from "./Interactivity.vue?vue&type=script&lang=js"
export * from "./Interactivity.vue?vue&type=script&lang=js"
import style0 from "./Interactivity.vue?vue&type=style&index=0&id=089173c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089173c8",
  null
  
)

export default component.exports